import { ClienteModel } from './../model/cliente.model';
import { BuscarOrdemServicoIn } from './../model/buscar-ordem-servico-in.model';
import { Component, OnInit } from '@angular/core';
import { OrdemServicoService } from '../service/ordem-servico.service';
import { constants } from '../app-constants';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import {OrdemServicoDialogComponent} from '../ordem-servico-dialog/ordem-servico-dialog.component';
import {DialogService, SelectItem} from 'primeng/api';
import {DatePipe} from '@angular/common';
import {TipoOsParamModel} from '../model/tipo-os-param.model';
import {PaginacaoParamModel} from '../model';
import {ActivatedRoute} from '@angular/router';
import {ImprimirOsDialogComponent} from '../imprimir-os-dialog/imprimir-os-dialog.component';
import {DataService} from '../service/data.service';
import {QrCodeDialogComponent} from '../qr-code-dialog/qr-code-dialog.component';

@Component({
  selector: 'app-lista-os-encerrada',
  templateUrl: './lista-os-encerrada.component.html',
  styleUrls: ['./lista-os-encerrada.component.css'],
  styles: ['.search-results { height : 100%; overflow-y: scroll;}']
})

export class ListaOsEncerradaComponent implements OnInit {

  numberPage = 1;
  buscarOrdemServicoIn: BuscarOrdemServicoIn = new BuscarOrdemServicoIn();
  ordensEncerradas: Array<any> = [];
  tipoOs: Array<any> = [];
  colunas: any[];
  motivoOs: Array<any> = [];
  cliente: ClienteModel;
  tipoOsParam: TipoOsParamModel = new TipoOsParamModel();
  paginacao: PaginacaoParamModel = new PaginacaoParamModel();
  enderecos: Array<any> = [];
  equipes: Array<any> = [];
  ativo: any;
  timer = 0;
  qrCodeSearch = false;
  firstMessage = false;

  displayModal = false;

  filters: {
    cod: {flag: boolean, value: any},
    end: {flag: boolean, value: any},
    equ: {flag: boolean, value: any},
    tip: {flag: boolean, value: any},
    dcr: {flag: boolean, value: any},
    dag: {flag: boolean, value: any},
    den: {flag: boolean, value: any},
    mot: {flag: boolean, value: any}
  };

  constructor(private router: ActivatedRoute,
              private ordemServicoService: OrdemServicoService,
              private loadingBar: NgxUiLoaderService,
              public dialogService: DialogService,
              private data: DataService) { }

  ngOnInit() {
    this.cliente = JSON.parse(localStorage.getItem(constants.clienteKey));
    this.qrCodeSearch = false;


    this.filters = {
      cod: {flag: false, value: null},
      end: {flag: false, value: null},
      equ: {flag: false, value: null},
      tip: {flag: false, value: null},
      dcr: {flag: false, value: null},
      dag: {flag: false, value: null},
      den: {flag: false, value: null},
      mot: {flag: false, value: null}
    };

    if (this.cliente !== undefined) {
      this.listar();
    }

    this.colunas = [
      {field: 'codigo', header: 'Código'},
      {field: 'resumoTipoOSAux', header: 'Tipo da Ordem de Serviço'},
      {field: 'enderecoCompleto', header: 'Endereço'},
      {field: 'ativosRequeridos', header: 'Ativo Requerido'},
      {field: 'nome', header: 'Tecnico (Equipe)'},
      {field: 'dataCriacao', header: 'Data Criação'},
      {field: 'dataDisponibilidade', header: 'Data Agendada'},
      {field: 'dataUltimoStatus', header: 'Data Encerramento'},
      {field: 'descricaoMotivoStatus', header: 'Motivo de Encerramento'},
      {field: 'observacoes', header: 'Observações'}
    ];

    this.paginacao.paginaAtual = 1;
    this.paginacao.registrosPorPagina = 50;

    this.listarFiltros();
    this.listarEnderecos(this.paginacao);
    this.listarEquipes(this.paginacao);
    this.listarMotivo(this.paginacao);

    this.data.currentMessage.subscribe(message => {
      if (message === 'fechada') {
        this.firstMessage = true;
        return;
      } else if (this.firstMessage === true) {
        this.ordensEncerradas = [];
        this.qrCodeSearch = true;
        const res = JSON.parse(message);
        res.forEach(item => {
          item.dataCriacao = new Date(item.dataCriacao);
          item.dataCriacao = new DatePipe('pt-BR').transform(item.dataCriacao, constants.dateFormat);
          item.dataDisponibilidade = new Date(item.dataDisponibilidade);
          item.dataDisponibilidade = new DatePipe('pt-BR').transform(item.dataDisponibilidade, constants.dateFormat);
          item.dataUltimoStatus = new Date(item.dataUltimoStatus);
          item.dataUltimoStatus = new DatePipe('pt-BR').transform(item.dataUltimoStatus, constants.dateFormat);
          this.ordensEncerradas.push(item);
        });
        this.firstMessage = false;
      }
    });
  }

  listar() {
    this.populaOrdemServicoIn();
    this.loadingBar.start();
    this.ordemServicoService.listarOsS(this.buscarOrdemServicoIn)
    .subscribe(
      response => {
        this.numberPage++;
        this.onSuccess(response.ordemServicoOut);
        this.loadingBar.stop();
      },
      error => {
        console.log(error);
        this.loadingBar.stop();
      }
    );
  }

  onSuccess(res) {
    if (res) {
      res.forEach(item => {
        item.dataCriacao = new Date(item.dataCriacao);
        item.dataCriacao = new DatePipe('pt-BR').transform(item.dataCriacao, constants.dateFormat);
        item.dataDisponibilidade = new Date(item.dataDisponibilidade);
        item.dataDisponibilidade = new DatePipe('pt-BR').transform(item.dataDisponibilidade, constants.dateFormat);
        item.dataUltimoStatus = new Date(item.dataUltimoStatus);
        item.dataUltimoStatus = new DatePipe('pt-BR').transform(item.dataUltimoStatus, constants.dateFormat);
        if (item.ativosRequeridos == null) {
          item.ativosRequeridos = [];
        } else {
          const atvAux = [];
          item.ativosRequeridos.forEach( item_interno => {
            atvAux.push(item_interno.numeroSerie + ' / ' + item_interno.numeroPatrimonio + ' ' +
              item_interno.descricao + ' (' + item_interno.fabricante + ') - ' + item_interno.modelo);
          });
          item.ativosRequeridos = atvAux;
        }

        this.ordensEncerradas.push(item);
      });
    }
  }

  imprimir(os) {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.buscarOrdemServicoIn.codigo = os.codigo;
      this.buscarOrdemServicoIn.status = window.location.hostname;
      this.loadingBar.start();
      this.ordemServicoService.imprimirOsS(this.buscarOrdemServicoIn).subscribe(response => {
          this.numberPage++;
          this.loadingBar.stop();
          if (response.ordemServicoOut == null || response.ordemServicoOut[0].codigo == null) {
            alert('Erro ao imprimir ordem de serviço');
          } else {
            if (!response.ordemServicoOut[0].codigo.includes('http')) {
              alert(response.ordemServicoOut[0].codigo);
            } else {
              const ref = this.dialogService.open(ImprimirOsDialogComponent, {
                data: response.ordemServicoOut[0].codigo,
                header: '',
                dismissableMask: true,
                width: '80%',
                height: '60%'
              });
            }
          }
        },
        error => {
          console.log(error);
          this.loadingBar.stop();
        });
    }, 500);
  }

  mostrar(os) {
    const ref = this.dialogService.open(OrdemServicoDialogComponent, {
      data: JSON.stringify(os),
      header: 'Detalhamento',
      width: '70%',
      contentStyle: {'max-height': '350px', 'overflow': 'auto'}
    });
  }

  buscarQRCode() {
    this.displayModal = false;
    const ref = this.dialogService.open(QrCodeDialogComponent, {
      data: JSON.stringify(this.buscarOrdemServicoIn.listStatusOs),
      header: 'Busca por QR Code',
      width: '70%',
      contentStyle: {'max-height': '350px', 'overflow': 'auto'}
    });
  }

  public onScroll() {
    this.buscarOrdemServicoIn.paginaAtual = this.numberPage;
    this.listar();
  }

  public listarFiltros () {
    this.ordemServicoService.listarTiposOSFiltro(this.tipoOsParam)
      .subscribe(response => {
        this.onSuccess_2(response.tipoResumo);
        this.loadingBar.stop();
      });
  }

  onSuccess_2 (res) {
    if (res) {
      res.forEach(item => {
        const auxTipo = {label: item, value: item};
        this.tipoOs.push(auxTipo);
      });
      this.tipoOs = this.tipoOs.sort((tipoOsA, tipoOsB) => tipoOsA['label'] > tipoOsB['label'] ? 1 : -1);
    }
  }

  public listarEnderecos(paginacao: PaginacaoParamModel) {
    this.loadingBar.start();
    this.ordemServicoService.listarEnderecos(paginacao)
      .subscribe(response => {
        this.onSuccess_3(response.enderecos);
        this.loadingBar.stop();
      });
  }
  onSuccess_3(res) {
    if (res) {
      res.forEach(endereco => {
        this.enderecos.push({label: endereco.enderecoCompleto, value: endereco.enderecoCompleto, id: endereco.enderecoId});
      });
    }
  }

  public listarEquipes(paginacao: PaginacaoParamModel) {
    this.loadingBar.start();
    this.ordemServicoService.listarEquipes(paginacao)
      .subscribe(response => {
        this.onSuccess_4(response.equipeOuts);
        this.loadingBar.stop();
      });
  }
  onSuccess_4(res) {
    if (res) {
      res.forEach(tecnico => {
        this.equipes.push({label: tecnico.tecnico, value: tecnico.tecnico, login: tecnico.login});
      });
    }
  }

  listarMotivo (paginacao: PaginacaoParamModel) {
    this.loadingBar.start();
    this.ordemServicoService.listarMotivo(paginacao)
      .subscribe(response => {
        this.onSuccess_5(response.motivosOut);
        this.loadingBar.stop();
      });
  }
  onSuccess_5 (res) {
    res.forEach(item => {
      this.motivoOs.push({label: item.descricao, value: item.descricao, id: item.id});
    });
  }

  limparBusca() {
    this.ordensEncerradas = new Array<any>();
    this.numberPage = 1;
    this.qrCodeSearch = false;
    this.listar();
  }

  buscarOSPorEndereco (endereco) {
    if (endereco.value.length >= 1) {
      this.enderecos.forEach(item => {
        if (item.label === endereco.value[0]) {
          this.filters.end.flag = true;
          this.filters.end.value = item.id;
        }
      });
    } else {
      this.filters.end.flag = false;
    }
    if (this.cliente !== undefined) {
      this.ordensEncerradas = new Array<any>();
      this.numberPage = 1;
      this.listar();
    }
  }

  buscarOSPorCodigo (cod) {
    if (cod.length < 3) {
      this.filters.cod.flag = false;
      alert('Não é possível buscar código com menos de 3 caracteres!');
    } else {
      cod = '%' + cod + '%';
      this.filters.cod.value = cod;
      this.filters.cod.flag = true;
      this.ordensEncerradas = new Array<any>();
      this.numberPage = 1;
      this.listar();
    }
  }

  buscarOSPorEquipe (equipe) {
    if (equipe.value.length > 0) {
      this.equipes.forEach(item => {
        if (item.label === equipe.value[0]) {
          this.filters.equ.value = item.login;
          this.filters.equ.flag = true;
        }
      });
    } else {
      this.filters.equ.flag = false;
    }
    this.ordensEncerradas = new Array<any>();
    this.numberPage = 1;
    this.listar();
  }

  buscarOSPorTipo (tipo) {
    if (tipo.value.length > 0) {
      this.tipoOs.forEach(item => {
        if (item.label === tipo.value[0]) {
          this.filters.tip.value = item.value;
          this.filters.tip.flag = true;
        }
      });
    } else {
      this.filters.tip.flag = false;
    }
    this.ordensEncerradas = new Array<any>();
    this.numberPage = 1;
    this.listar();
  }

  buscarOSPorDataCriacao (data) {
    if (data != null) {
      this.filters.dcr.flag = true;
      this.filters.dcr.value = data;
    } else {
      this.filters.dcr.flag = false;
    }
    this.ordensEncerradas = new Array<any>();
    this.numberPage = 1;
    this.listar();
  }

  buscarOSPorDataAgendamento (data) {
    if (data != null) {
      this.filters.dag.flag = true;
      this.filters.dag.value = data;
    } else {
      this.filters.dag.flag = false;
    }
    this.ordensEncerradas = new Array<any>();
    this.numberPage = 1;
    this.listar();
  }

  buscarOSPorDataEncerramento(data) {
    if (data != null) {
      this.filters.den.flag = true;
      this.filters.den.value = data;
    } else {
      this.filters.den.flag = false;
    }
    this.numberPage = 1;
    this.ordensEncerradas = new Array<any>();
    this.listar();
  }

  buscarOSPorMotivo (motivo) {
    if (motivo.value.length > 0) {
      this.motivoOs.forEach(item => {
        if (item.label === motivo.value[0]) {
          this.filters.mot.flag = true;
          this.filters.mot.value = item.id;
          }
      });
    } else {
      this.filters.mot.flag = false;
    }
    this.numberPage = 1;
    this.ordensEncerradas = new Array<any>();
    this.listar();
  }

  populaOrdemServicoIn () {
    this.buscarOrdemServicoIn.paginaAtual = this.numberPage;
    this.buscarOrdemServicoIn.contratoId = this.cliente.clienteContratoId;
    this.buscarOrdemServicoIn.listStatusOs = [7];
    if (this.filters.end.flag) {
      this.buscarOrdemServicoIn.enderecoId = this.filters.end.value;
    } else {
      this.buscarOrdemServicoIn.enderecoId = null;
    }
    if (this.filters.cod.flag) {
      this.buscarOrdemServicoIn.codigo = this.filters.cod.value;
    } else {
      this.buscarOrdemServicoIn.codigo = null;
    }
    if (this.filters.equ.flag) {
      this.buscarOrdemServicoIn.tecnicoFiltro = this.filters.equ.value;
    } else {
      this.buscarOrdemServicoIn.tecnicoFiltro = null;
    }
    if (this.filters.tip.flag) {
      this.buscarOrdemServicoIn.buscaFiltro = this.filters.tip.value;
    } else {
      this.buscarOrdemServicoIn.buscaFiltro = null;
    }
    if (this.filters.dcr.flag) {
      this.buscarOrdemServicoIn.dataCriacaoFiltro = this.filters.dcr.value;
    } else {
      this.buscarOrdemServicoIn.dataCriacaoFiltro = null;
    }
    if (this.filters.dag.flag) {
      this.buscarOrdemServicoIn.dataAgendadaFiltro = this.filters.dag.value;
    } else {
      this.buscarOrdemServicoIn.dataAgendadaFiltro = null;
    }
    if (this.filters.den.flag) {
      this.buscarOrdemServicoIn.dataEncerramentoFiltro = this.filters.den.value;
    } else {
      this.buscarOrdemServicoIn.dataEncerramentoFiltro = null;
    }
    if (this.filters.mot.flag) {
      this.buscarOrdemServicoIn.motivoFiltro = this.filters.mot.value;
    } else {
      this.buscarOrdemServicoIn.motivoFiltro = null;
    }
  }
}
